import React, { useState } from 'react';
import RcTooltip from 'rc-tooltip';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import { COLOR } from '@src/styles/color';
import { variantMapping } from './variants';
import { StyledDropdown, StyledSortVoiceFilterButton } from './index.style';

import Typography from '../Typography';

const MultiSelect = ({
  options,
  startIcon,
  title,
  onChange,
  variant,
  disabled,
  value,
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipVisibleChange = (visible) => {
    setIsTooltipOpen(visible);
  };

  const renderArrow = (anchorDropdown) => {
    if (anchorDropdown) {
      return (
        <ArrowDropUpRoundedIcon
          sx={{ color: COLOR.navyBlue, fontSize: '24px' }}
        />
      );
    }
    return (
      <ArrowDropDownRoundedIcon
        sx={{ color: COLOR.navyBlue, fontSize: '24px' }}
      />
    );
  };

  return (
    <>
      {isTooltipOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'transparent',
            zIndex: 9999,
            pointerEvents: 'auto',
          }}
          onWheel={(e) => e.preventDefault()}
          onTouchMove={(e) => e.preventDefault()}
        />
      )}
      <RcTooltip
        placement="bottomRight"
        overlay={
          <StyledSortVoiceFilterButton>
            {options.map((item) => (
              <div
                role="button"
                tabIndex={0}
                onClick={() => {
                  onChange(item.value);
                }}
                className="item"
                key={item.value}
              >
                <Typography variant="body-14-medium" color={COLOR.darkGray}>
                  {item.label}
                </Typography>
                {value?.includes(item.value) && (
                  <CheckRoundedIcon
                    sx={{ color: COLOR.navyBlue, fontSize: '24px' }}
                  />
                )}
              </div>
            ))}
          </StyledSortVoiceFilterButton>
        }
        trigger={['click']}
        showArrow={false}
        align={{
          offset: [0, 5],
        }}
        onVisibleChange={handleTooltipVisibleChange}
        visible={isTooltipOpen}
        zIndex={10000}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'transparent',
          zIndex: 9999,
          pointerEvents: 'auto',
        }}
        onWheel={(e) => e.preventDefault()}
        onTouchMove={(e) => e.preventDefault()}
      >
        <StyledDropdown metaData={variantMapping[variant]}>
          <div className={`dropdown-container ${disabled ? 'disabled' : ''}`}>
            <div className="dropdown-title">
              {startIcon}
              {title}
            </div>
            {renderArrow(isTooltipOpen)}
          </div>
        </StyledDropdown>
      </RcTooltip>
    </>
  );
};

export default MultiSelect;
